<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button type="primary" @click="ejectaddGoods">新增商品</el-button>
      </el-form-item>
      <el-form-item label="分类: " style="margin:0 30PX">
        <el-select
          style="width:260px"
          v-model="select_one_id"
          placeholder="请选择"
          @change="selectNextCategoryBtn"
          clearable
        >
          <div v-for="item in categoryArr" :key="item.id">
            <el-option :label="item.categoryName" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称: " style="margin-left:20px">
        <el-input
          v-model="productName"
          placeholder="请输入商品名称"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="selectAll">搜索</el-button>
      </el-form-item>
      <!-- <el-form-item label="二级分类:">
            <el-select
              v-model="select_two_id"
              placeholder="请选择"
              @change="selectGoodsByIdBtn"
            >
              <div v-for="item in nextCategoryArr" :key="item.id">
                <el-option :label="item.categoryName" :value="item.id"></el-option>
              </div>
            </el-select>
          </el-form-item> -->
    </el-form>
    <!-- 商品表格 -->
    <div style="height:80%">
      <el-table
        border
        :data="goodsArr"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-text="正在加载中"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="商品ID" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.id ? scope.row.id : "暂无id" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品主图" width="100" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 60px; max-height: 60px"
              :src="scope.row.coverImg"
              :preview-src-list="[scope.row.coverImg]"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="产品名" width="200" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.productName }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="商品库存" width="200" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.stockNum }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="零售价" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.price }}元</span>
          </template>
        </el-table-column>
        <el-table-column label="会员价" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.discountPrice }}元</span>
          </template>
        </el-table-column>
        <el-table-column label="商品编码" width="180" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.productCode ? scope.row.productCode : "暂无编码"
            }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="产品类型" align="center">
<template slot-scope="scope">
    <span>{{ scope.row.productType }}</span>
</template>
        </el-table-column> -->
        <!-- <el-table-column label="产品描述" align="center">
<template slot-scope="scope">
    <el-popover trigger="hover" placement="top">
        <p>{{ scope.row.introduce }}</p>
        <div slot="reference" class="name-wrapper">
            <el-tag size="medium">{{ scope.row.introduce ? scope.row.introduce : "暂无" }}
            </el-tag>
        </div>
    </el-popover>
</template>
        </el-table-column> -->
        <!-- <el-table-column
          label="商品封面图"
          :label-width="formLabelWidth"
          width="100"
        >
<template slot-scope="scope">
    <img :src="scope.row.coverImg" alt style="width:100%" />
</template>
        </el-table-column> -->
        <el-table-column label="状态" min-width="100" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.status === 0
                ? "上架"
                : scope.row.status === 1
                ? "预售"
                : scope.row.status === 2
                ? "补货"
                : scope.row.status === 3
                ? "下架"
                : "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="视频链接" align="center" width="250">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>
                {{ scope.row.videoLink }}
              </p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium" class="text-hide"
                  >{{ scope.row.videoLink ? scope.row.videoLink : "暂无" }}
                </el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="上架时间" min-width="200" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="ejectupdataGoods(scope.row)">
              编辑</el-button
            >
            <el-button size="mini" type="danger" @click="deleteGoods(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 产品提交表单 -->
    <el-dialog
      :title="inpitTypeName"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      top="0"
      :fullscreen="true"
    >
      <el-form :model="form" :label-width="formLabelWidth">
        <el-form-item label="商品状态:" :label-width="formLabelWidth">
          <el-select v-model="form.status" placeholder="不填写默认为上架">
            <div v-for="item in statusArr" :key="item.id">
              <el-option :label="item.status" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="商品类型: " required>
          <el-select v-model="form.type" placeholder="请选择商品类型">
            <div v-for="item in typeList" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="选择兑换商品: " required v-if="form.type === 1">
          <el-select
            v-model="form.coupons"
            multiple
            filterable
            placeholder="请输入关键词搜索商品"
            style="width: 100%;"
          >
            <el-option
              v-for="item in goodsArr"
              :key="item.id"
              :label="item.productName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品分类: " required>
          <el-select
            multiple
            v-model="productCategoryList"
            placeholder="请选择商品分类"
            style="width: 100%;"
          >
            <div v-for="item in categoryArr" :key="item.id">
              <el-option
                :label="item.categoryName"
                :value="item.id + ''"
              ></el-option>
            </div>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="二级分类:" v-if="select_one_id !== ''">
          <el-select v-model="select_two_id" placeholder="二级分类">
            <div v-for="item in nextCategoryArr" :key="item.id">
              <el-option
                :label="item.categoryName"
                :value="item.id"
              ></el-option>
            </div>
          </el-select>
        </el-form-item> -->
        <el-form-item label="商品所属门店:" :label-width="formLabelWidth">
          <!-- collapse-tags -->
          <el-select
            v-model="selectStoreList"
            placeholder="不填写默认为所有用户能查看"
            multiple
            style="width:100%"
          >
            <div v-for="item in storeArr" :key="item.id">
              <el-option
                :label="item.storeName"
                :value="item.id + ''"
              ></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="商品编码" :label-width="formLabelWidth">
          <el-input v-model="form.productCode" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品名称" required>
          <el-input v-model="form.productName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="零售价" required>
          <el-input v-model="form.price" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="会员价" required>
          <el-input v-model="form.discountPrice" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品库存" :label-width="formLabelWidth">
          <el-input v-model="form.stockNum" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="商品描述(请勿输入&特殊字符)"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.introduce"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="银卡会员价" :label-width="formLabelWidth">
          <el-input v-model="form.priceOne" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="金卡会员价" :label-width="formLabelWidth">
          <el-input v-model="form.priceTwo" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="白金卡会员价" :label-width="formLabelWidth">
          <el-input v-model="form.priceThree" auto-complete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="商品视频链接" :label-width="formLabelWidth">
          <el-input
            v-model="form.videoLink"
            auto-complete="off"
            placeholder="没有则不要输入,不要输入无"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="商品封面图"
          :label-width="formLabelWidth"
          width="100"
          required
        >
          <img :src="form.coverImg" alt style="width:100px" />
          <el-upload
            class="upload-demo"
            :action="action"
            :multiple="true"
            :on-remove="handleRemove"
            :on-success="coverImgBtn"
            :file-list="fileList"
            list-type="picture"
            name="formData"
            style="margin: 0;"
          >
            <el-button size="small" type="primary"
              >点击更换商品封面图(1张)</el-button
            >
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，500px X 500px
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <!-- 上传文件到服务器 -->

      <el-upload
        class="upload-demo"
        :action="action"
        :multiple="true"
        :on-remove="handleRemove"
        :on-success="headerImgBtn"
        :file-list="fileList"
        list-type="picture"
        name="formData"
      >
        <el-button size="small" type="primary">点击上传商品主图(5张)</el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传jpg/png文件，500px X 500px
        </div>
      </el-upload>

      <el-upload
        class="upload-demo"
        :action="action"
        :multiple="true"
        :on-remove="handleRemove"
        :on-success="detailsImgBtn"
        :file-list="fileList"
        list-type="picture"
        name="formData"
      >
        <el-button size="small" type="primary"
          >点击上传商品详情图（10张内）</el-button
        >
        <div slot="tip" class="el-upload__tip">
          只能上传jpg/png文件，500px X 500px
        </div>
      </el-upload>
      <!-- <div style="padding: 10px 15px" v-if="inpitTypeName === '修改商品详情'">
        <el-button type="success" size="mini" @click="addSkuDialog"
          >新增价格区间</el-button
        >
        <el-button type="success" size="mini" @click="deleteSkuById"
          >删除价格区间</el-button
        >
        <div class="sku">
          <div
            v-for="item in sku"
            :key="item.id"
            :class="{ skuBg: item.id === skuActive }"
            @click="skuActiveBtn(item.id)"
          >
            {{ item.minNum }}-{{ item.maxNum }}{{ item.sku }}/{{ item.price }}
          </div>
        </div>
      </div> -->

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updataBtn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- sku弹窗 -->
    <el-dialog title="价格区间设置" :visible.sync="skuVisible">
      <el-form :model="skuForm">
        <el-form-item label="单位" :label-width="formLabelWidth">
          <el-input v-model="skuForm.sku" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="价钱" :label-width="formLabelWidth">
          <el-input v-model="skuForm.price" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="最低数量" :label-width="formLabelWidth">
          <el-input v-model="skuForm.minNum" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="最高数量" :label-width="formLabelWidth">
          <el-input v-model="skuForm.maxNum" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="skuVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSkuBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectGoods,
  addGoods,
  updateGoods,
  deleteGoodbyid,
  selectCategory,
  // selectCategoryTwo,
  deleteGoodsbygoodsId,
} from "@/services/goods";
// , deleteSku;
import { addSku, selectSku, deleteSku } from "@/services/sku";
import { selectStore } from "@/services/store";
export default {
  created() {
    this.selectAll();
    // 查询一级分类
    selectCategory("0").then((res) => {
      console.log(res);
      this.categoryArr = res.data;
    });

    //查询门店数据
    selectStore({
      storeName: "",
    }).then((resp) => {
      console.log("selectStore===========", resp.data);
      this.storeArr = resp.data;
    });
  },

  data() {
    return {
      typeList: [
        { id: 0, name: "商品" },
        { id: 1, name: "卡券" },
      ],
      status: 0,
      statusArr: [
        { id: 0, status: "上架" },
        { id: 1, status: "预售" },
        { id: 2, status: "补货" },
        { id: 3, status: "下架" },
      ],
      storeArr: [], //门店数据
      selectStoreList: [], //选择的门店数据
      productCategoryList: [],
      goodsTitle: "",
      tableData: [],
      categoryId: "",
      productName: "",
      // 一级分类 二级分类 商品
      select_one_id: "",
      select_two_id: "",
      categoryArr: [],
      nextCategoryArr: [],
      goodsArr: [],
      dialogFormVisible: false,
      formLabelWidth: "120px",
      action: "https://mini-xili.bboycc.cn/uploadFile/add",
      fileList: [],
      loading: true,
      form: {},
      inpitTypeName: "",
      headerImg: [],
      detailsImg: [],
      sku: [], //sku数组
      skuActive: "",
      skuForm: {
        //新增sku
        productId: "",
        price: "",
        sku: "",
      },
      skuVisible: false,
    };
  },
  methods: {
    selectAll() {
      selectGoods({
        productCategory: this.select_one_id,
        productName: this.productName,
      }).then((resp) => {
        console.log(resp);
        this.loading = false;
        this.goodsArr = resp.data;
      });
    },
    // 根据一级分类id查二级分类
    selectNextCategoryBtn(e) {
      console.log(e);
      // this.select_two_id = "";
      // selectCategoryTwo(e).then((res) => {
      //   console.log(res);
      //   this.nextCategoryArr = res.data;
      // });
      this.selectAll();
    },
    // 通过二级分类id查商品
    selectGoodsByIdBtn() {
      this.selectAll();
    },
    /**
     * 查询sku
     * @param {productId} 商品id
     */
    selectSkuById(productId) {
      selectSku(productId).then((res) => {
        console.log(res);
        this.sku = res.data;
      });
    },
    addSkuDialog() {
      this.skuVisible = true;
    },
    addSkuBtn() {
      if (
        this.skuForm.price === "" ||
        this.skuForm.sku === "" ||
        this.skuForm.minNum === "" ||
        this.skuForm.maxNum === ""
      ) {
        return this.$message.error("选项不能为空");
      }
      addSku({ ...this.skuForm, productId: this.form.id }).then(() => {
        this.selectSkuById(this.form.id);
        this.skuVisible = false;
      });
    },
    deleteSkuById() {
      if (this.skuActive === "") {
        return this.$message.error("请选择要删除的sku");
      }
      console.log("this.skuActive", this.skuActive);
      deleteSku(this.skuActive).then(() => {
        this.selectSkuById(this.form.id);
      });
    },
    skuActiveBtn(id) {
      console.log(id);
      this.skuActive = id;
    },
    coverImgBtn(e) {
      this.form.coverImg = e.data;
    },
    headerImgBtn(e) {
      this.headerImg.push(e.data);
    },
    detailsImgBtn(e) {
      this.detailsImg.push(e.data);
    },
    handleRemove(e, fileList) {
      console.log("移除---------------", e, fileList);
    },

    /* 编辑弹窗 */
    ejectupdataGoods(row) {
      console.log(row);
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改商品详情";
      this.form = JSON.parse(JSON.stringify(row));
      this.select_two_id = row.productCategory;
      if (this.form.type == 1) {
        this.form.coupons = JSON.parse(this.form.coupons).map((item) => {
          return item.id;
        });
      }
      if (this.form.storeId && this.form.storeId != "0") {
        this.selectStoreList = this.form.storeId.split(",");
      } else {
        this.form.storeId = null;
        this.selectStoreList = [];
      }
      this.productCategoryList = this.form.productCategory.split(",");
      this.headerImg = [];
      this.detailsImg = [];
      this.fileList = [];
      this.skuActive = "";
      // this.selectSkuById(row.id); //查询sku
    },

    ejectaddGoods() {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增商品";
      this.headerImg = [];
      this.detailsImg = [];
      this.fileList = [];
      this.form = {};
      this.select_one_id = "";
      this.select_two_id = "";
      this.selectStoreList = [];
      this.productCategoryList = [];
      this.form.storeId = null;
    },
    // 提交表单按钮
    updataBtn() {
      console.log("点击了确认", this.form, this.form.coupons);

      let goods = this.form;
      let headerImg = this.headerImg;
      let detailsImg = this.detailsImg;

      if (
        this.form.type == 1 &&
        (!this.form.coupons || this.form.coupons.length == 0)
      ) {
        this.$message.error("请选择兑换商品");
        return;
      }

      let newCoupons = null;
      if (this.form.type == 1) {
        newCoupons = this.form.coupons.map((i) => {
          let item = this.goodsArr.find((item1) => i == item1.id);
          return item;
        });
      }
      console.log("his.selectStoreList", this.selectStoreList);
      if (this.selectStoreList.length > 0) {
        this.form.storeId = this.selectStoreList.join(",");
      } else {
        this.form.storeId = null;
      }

      if (this.productCategoryList.length > 0) {
        this.form.productCategory = this.productCategoryList.join(",");
      } else {
        this.form.productCategory = "";
      }

      if (
        !this.form.productCategory ||
        !this.form.productName ||
        !this.form.coverImg ||
        !this.form.price ||
        !this.form.discountPrice
      ) {
        this.$message.error("必填选项不能为空");
        return;
      }
      if (this.inpitTypeName == "修改商品详情") {
        updateGoods(
          { ...goods, coupons: newCoupons },
          headerImg,
          detailsImg
        ).then((resp) => {
          console.log(resp);
          if (resp.code == 200) {
            this.$message.success("修改成功");
            this.dialogFormVisible = false;
            this.selectAll();
          } else {
            this.$message.error("修改失败");
          }
        });
      } else if (this.inpitTypeName == "新增商品") {
        addGoods({ ...goods, coupons: newCoupons }, headerImg, detailsImg).then(
          (resp) => {
            console.log(resp);
            if (resp.code == 200) {
              this.$message.success("上传成功");
              this.dialogFormVisible = false;
              this.selectAll();
            } else {
              this.$message.error("上传失败");
            }
          }
        );
      }
    },
    deleteGoods(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteGoodbyid(row.id).then((resp) => {
            console.log(resp);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            deleteGoodsbygoodsId(row.id).then((res) => {
              console.log(res);
            });
            this.selectAll();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}

.el-pagination {
  text-align: center;
  margin: 20px;
}

.goodsTitle:hover {
  cursor: pointer;
}

.upload-demo {
  margin: 20px;
}

.sku {
  border: 1px dotted rgb(189, 189, 189);
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;
}

.sku > div {
  margin-right: 10px;
  padding: 10px 20px;
  background: rgb(245, 138, 44);
  border-radius: 10px;
  color: white;
}

.sku > div:hover {
  cursor: pointer;
}

.skuBg {
  background: rgb(254, 66, 3) !important;
}
</style>
